var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.7,
    height: 41.7,
    viewBox: "0 0 41.7 41.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 41.7,
    height: 41.7,
    rx: 10,
    ry: 10,
    fill: "#4195c7",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.85,37.29c-9.07,0-16.44-7.38-16.44-16.44S11.79,4.41,20.85,4.41s16.44,7.38,16.44,16.44-7.38,16.44-16.44,16.44Zm0-32.46c-8.84,0-16.02,7.19-16.02,16.02s7.19,16.02,16.02,16.02,16.02-7.19,16.02-16.02S29.69,4.83,20.85,4.83Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.96,32.04h0c-3.09-.02-5.92-1.56-7.56-4.14-1.55-2.43-1.78-5.4-.61-7.95,1.43-3.13,3.64-5.69,5.78-8.17.48-.56.96-1.12,1.43-1.68.24-.29.52-.44.83-.44.46,0,.73.32.87.5.46.56.93,1.11,1.4,1.66,1.77,2.07,3.6,4.22,5.01,6.68.83,1.45,1.59,3.04,1.53,4.89-.15,4.77-3.89,8.49-8.68,8.66h0Zm-.13-21.96c-.27,0-.45.21-.51.29-.47.57-.96,1.13-1.44,1.69-2.12,2.46-4.31,5-5.72,8.07-1.11,2.42-.89,5.24.58,7.55,1.57,2.45,4.26,3.93,7.21,3.95,4.57-.16,8.13-3.71,8.28-8.25.06-1.75-.67-3.28-1.47-4.67-1.39-2.42-3.21-4.55-4.96-6.61-.47-.55-.94-1.1-1.41-1.66-.12-.15-.29-.35-.55-.35Zm.02,19.78l-.02-.42c3.16-.14,5.68-2.63,6-5.92l.41.04c-.34,3.5-3.02,6.15-6.39,6.3Z",
    fill: "#fff",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.7c8984b16a20c4d1ec80561131a89f49.svg";
export { ForwardRef as ReactComponent };